import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const decreesData = [
  {
    title: "Décret N°100/152 du 16 novembre 2022 portant création, attributions, composition et règles de fonctionnement du Comité National de l'Information Statistique (CNIS)",
    principalLink: "/documents/decrees/Decret-N°-100-152-Portant-Creation-Attributions-Composition-et-Regles-de-Focntionnement-du-CNIS-au-16-novembre-2022.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "Le Comité National de l'Information Statistique (CNIS) est établi par ce décret, qui définit ses rôles, sa structure et ses procédures opérationnelles.",
    date: "2022-11-16",
    publicationDate: "2022-11-16"
  },
  {
    title: "Décret N°100/153 du 16 novembre 2022 portant création, attributions, composition et règles de fonctionnement de l'Autorité Statistique Nationale (Institut National de Statistique du Burundi, INSBU)",
    principalLink: "/documents/decrees/Decret-N°-100-153-Portant-Creation-Attributions-Composition-et-Regles-de-fonctionnement-de-lINSBU-au-16-novembre-2022-1.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "L'Autorité Statistique Nationale, l'Institut National de Statistique du Burundi (INSBU), est créée par ce décret, qui précise ses fonctions, son organisation et son fonctionnement.",
    date: "2022-11-16",
    publicationDate: "2022-11-16"
  },
  {
    title: "Décret N°100/146 du 17 mai 2021 portant nomination des membres du Comité National d'Orientation du Recensement Général (CNOR) de la population, de l'habitat, de l'agriculture et de l'élevage au Burundi de 2022",
    principalLink: "/documents/decrees/DECRET-N°100.146-DU-17-MAI-2021-PORTANT-NOMINATION-DES-MEMBRES-DU-CNOR-DU-RGPHAE-DE-2022-1.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "Les membres du Comité National d'Orientation du Recensement Général (CNOR) pour le recensement de 2022 sont nommés par ce décret.",
    date: "2021-05-17",
    publicationDate: "2021-05-17"
  },
  {
    title: "Décret N°100/109 du 30 novembre 2020 portant institution du recensement général de la population, de l'habitat, de l'agriculture et de l'élevage au Burundi de 2022",
    principalLink: "/documents/decrees/DECRET-N°100.109.-DU-30-NOVEMBRE-2020-PORTANT-INSTITUTION-DU-RECENSEMENT-GENERAL-DE-LA-POPULATION-DE-LHABITAT-DE-LAGRICULTURE-ET-DE-LELEVAGE-AU-BURUNDI-DE-2022-1.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "L'organisation du recensement général de la population, de l'habitat, de l'agriculture et de l'élevage au Burundi en 2022 est instituée par ce décret.",
    date: "2020-11-30",
    publicationDate: "2020-11-30"
  },
  {
    title: "Décret N°100/110 du 30 novembre 2020 portant institution de l'usage systématique des nomenclatures utilisées dans le système statistique national du Burundi",
    principalLink: "/documents/decrees/DECRET-N°100.110.-DU-30-NOVEMBRE-PORTANT-INSTITUTION-DE-LUSAGE-SYSTEMATIQUE-DES-NOMENCLATURES-UTILISEES-DANS-LE-SYSTEME-STATISTIQUE-NATIONAL-DU-BURUNDI.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "L'utilisation systématique des nomenclatures dans le système statistique national du Burundi est rendue obligatoire par ce décret.",
    date: "2020-11-30",
    publicationDate: "2020-11-30"
  },
  {
    title: "Décret N°100/037 du 19 avril 2018 portant révision du Décret N°100/29 du 18 septembre 2015 sur la structure, le fonctionnement et les missions du gouvernement de la République du Burundi",
    principalLink: "/documents/decrees/Décret-n°100.037-du-19-avril-2018-portant-révision-du-décret-10029-du-18-septembre-2015-portant-Structure-Fonctionnement-et-Missions-du-Gouvernement-de-la-République-du-Burundi-1.pdf",
    image: 'assets/decrees/gouvernance.PNG',
    description: "La structure, le fonctionnement et les missions du gouvernement de la République du Burundi sont révisés par ce décret.",
    date: "2018-04-19",
    publicationDate: "2018-04-19"
  },
  {
    title: "Décret N°100/085 du 25 juillet 2018 portant cadre national de collecte, de diffusion, d'accès, d'archivage et de sécurisation des données et de micro-données",
    principalLink: "/documents/decrees/DECRET-N°100.081-DU-20-JUILLET-2018-PORTANT-MISSIONS-ORGANISATION-ET-FONCTIONNEMENT-DU-MFBCDE.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "Le cadre national pour la collecte, la diffusion, l'accès, l'archivage et la sécurisation des données et micro-données est établi par ce décret.",
    date: "2018-07-25",
    publicationDate: "2018-07-25"
  },
  {
    title: "Décret N°100/084 du 25 juillet 2018 portant révision du Décret N°100/58 du 18 mars 2008 relatif à la création, aux attributions, à la composition et au fonctionnement du Conseil National de l'Information Statistique (CNIS)",
    principalLink: "/documents/decrees/DECRET-N°100.084-DU-25-JUILLET-2018-PORTANT-REVISION-DU-DERCET-N°100.58-DU-18-MARS-2008-PORTANT-CREATION-ATTRIBUTIONS-COMPOSITIONS-ET-FONCTIONNEMENT-.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "La création, les attributions, la composition et le fonctionnement du Conseil National de l'Information Statistique (CNIS) sont révisés par ce décret.",
    date: "2018-07-25",
    publicationDate: "2018-07-25"
  },

  {
    title: "Décret N°100/227 du 08 octobre 2014 portant cadre national d'assurance qualité des données (CNAQD) au Burundi",
    principalLink: "/documents/decrees/Décret-n°100.227-du-08-octobre-2014-portant-Cadre-National-dAssurance-Qualité-des-Données-CNAQD-au-Burundi-1.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "Le cadre national d'assurance qualité des données (CNAQD) au Burundi est mis en place par ce décret.",
    date: "2014-10-08",
    publicationDate: "2014-10-08"
  },
  {
    title: "Décret N°100/261 du 31 octobre 2013 portant institution du visa statistique et de l'avis d'éthique pour les enquêtes statistiques et recherches biomédicales et comportementales au Burundi",
    principalLink: "/documents/decrees/Décret-n°-100.261-du-31-octobre-2013-portant-institution-du-visa-statistique-et-de-lavis-dEthique-pour-les-enquêtes-statistiques-et-recherches-biomédicales-et-comportementales-au-Burundi-1.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "L'institution du visa statistique et de l'avis d'éthique pour certaines enquêtes et recherches au Burundi est établie par ce décret.",
    date: "2013-10-31",
    publicationDate: "2013-10-31"
  },

  {
    title: "Décret N°100/071 du 09 mars 2011 portant nomination du Conseil National de l'Information Statistique (CNIS)",
    principalLink: "/documents/decrees/Décret-n°-10071-du-09-mars-2011-portant-nomination-du-Conseil-National-de-lInformation-Statistique_CNIS-2.pdf",
    image: 'assets/decrees/confidentialite.PNG',
    description: "La nomination des membres du Conseil National de l'Information Statistique (CNIS) est officialisée par ce décret.",
    date: "2011-03-09",
    publicationDate: "2011-03-09"
  }
];

function Decrees() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredDecrees, setFilteredDecrees] = useState(decreesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    let filtered;

    if (year === 'Tous') {
      filtered = decreesData;
    } else {
      filtered = decreesData.filter((decree) => {
        const decreeYear = new Date(decree.date).getFullYear();
        return decreeYear === parseInt(year);
      });
    }

    // Trier par date de publication (les plus récents en premier)
    filtered.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
    setFilteredDecrees(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Décrets Relatifs au Système Statistique National
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            L'ensemble des décrets relatifs au Système Statistique National (SSN). Vous y trouverez les textes réglementaires essentiels qui régissent la gouvernance, la collecte, l'analyse et la diffusion des données statistiques au niveau national, ainsi que des ressources clés pour naviguer dans le cadre législatif du SSN.
          </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année d'adoption</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année d'adoption"
            >
              <MenuItem value="Tous">Tous les décrets</MenuItem>
              {[...new Set(decreesData.map((decree) => new Date(decree.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

   
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredDecrees.slice(0, visibleCount).map((decree, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={decree.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={decree.image}
                        alt={decree.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={decree.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{decree.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {decree.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié le {moment(decree.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredDecrees.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Décrets
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default Decrees;